import { getEnvironmentVariable } from "../../global/environmentVariables";
import HomeBanana from "./HomeBanana";
import HomeBCPProd from "./HomeBCPProd";
import HomeBCPStaging from "./HomeBCPStaging";
import HomeCatan from "./HomeCatan";
import HomeChronoCore from "./HomeChronoCore";
import HomeDefault from "./HomeDefault";
import HomePrimal from "./HomePrimal";
import HomeShardBugs from "./HomeShardBugs";
import HomeSoulMasters from "./HomeSoulMasters";
import HomeTesting from "./HomeTesting";
import HomeUnplug from "./HomeUnplug";
import HomeWarhammer from "./HomeWarhammer";
import HomeWarmachine from "./HomeWarmachine";
const AMPLIFY_BRANCH = getEnvironmentVariable("AMPLIFY_BRANCH");
const IS_UY = getEnvironmentVariable("IS_UY") === "true";
const IS_BG =
  getEnvironmentVariable("IS_BG") === "true" ||
  getEnvironmentVariable("COMPANY_FLAG") === "bananagrams";

export default function Home() {
  if (AMPLIFY_BRANCH === "bcp-prod") {
    return <HomeBCPProd />;
  }
  if (AMPLIFY_BRANCH === "bcp-staging") {
    return <HomeBCPStaging />;
  }
  if (
    AMPLIFY_BRANCH === "catan-gold" ||
    AMPLIFY_BRANCH === "catan-dev" ||
    AMPLIFY_BRANCH === "catan-prod"
  ) {
    return <HomeCatan />;
  }

  if (
    AMPLIFY_BRANCH === "bananagrams-dev" ||
    AMPLIFY_BRANCH === "bananagrams-prod" ||
    IS_BG
  ) {
    return <HomeBanana />;
  }

  if (IS_UY) {
    return <HomeUnplug />;
  }

  if (AMPLIFY_BRANCH === "primal-dev" || AMPLIFY_BRANCH === "primal-prod") {
    return <HomePrimal />;
  }
  if (
    AMPLIFY_BRANCH === "warmachine-dev" ||
    AMPLIFY_BRANCH === "warmachine-prod"
  ) {
    return <HomeWarmachine />;
  }
  if (
    AMPLIFY_BRANCH === "shard-bugs-dev" ||
    AMPLIFY_BRANCH === "shard-bugs-prod"
  ) {
    return <HomeShardBugs />;
  }
  if (
    AMPLIFY_BRANCH === "soul-masters-dev" ||
    AMPLIFY_BRANCH === "soul-masters-prod"
  ) {
    return <HomeSoulMasters />;
  }
  if (
    AMPLIFY_BRANCH === "chrono-core-dev" ||
    AMPLIFY_BRANCH === "chrono-core-prod"
  ) {
    return <HomeChronoCore />;
  }
  if (
    AMPLIFY_BRANCH === "warhammer-dev" ||
    AMPLIFY_BRANCH === "warhammer-prod"
  ) {
    return <HomeWarhammer />;
  }

  if (
    AMPLIFY_BRANCH === "testing" ||
    AMPLIFY_BRANCH === "bcp-dev" ||
    AMPLIFY_BRANCH === "testing-organizations-overhaul"
  ) {
    return <HomeTesting />;
  }
  return <HomeDefault />;
}
